(function () {
  const initHeader = () => {
    const body = document.body;
    const header = document.querySelector(".shopify-section-header");

    if (!header) return;

    const headerWrapper = header.querySelector(".header-wrapper");
    const headerDetails = document.querySelector(".menu-drawer-container");
    const headerIsAlwaysSticky =
      headerWrapper &&
      headerWrapper.getAttribute("data-sticky-type") === "always";

    if (headerDetails && !headerDetails.dataset.headerBound) {
      headerDetails.addEventListener("toggle", function () {
        const menuDrawer = this.querySelector("#menu-drawer");
        if (!menuDrawer) return;

        const colorScheme = menuDrawer.dataset.colorScheme;
        if (colorScheme) {
          header.classList.toggle(colorScheme);
        }
      });

      headerDetails.dataset.headerBound = "true";
    }

    const onKeyUp = (e) => {
      if (e.key === "Escape") {
        header.classList.remove("shopify-section-header-sticky", "animate");
        body.classList.remove("overflow-hidden");
      }
    };

    const onScroll = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > header.offsetHeight && headerIsAlwaysSticky) {
        header.classList.add("fixed", "animate");
      } else if (scrollTop <= header.offsetHeight && headerIsAlwaysSticky) {
        header.classList.remove("fixed", "animate");
      }
    };

    const addBackground = () => {
      if (
        header.classList.contains("color-inverse") &&
        !header.classList.contains("shopify-section-header-sticky")
      ) {
        header.classList.remove("color-inverse");
      }
    };

    const removeBackground = () => {
      if (body.classList.contains("overflow-hidden-tablet")) return;

      if (
        header.classList.contains("header-overlay") &&
        !header.classList.contains("shopify-section-header-sticky")
      ) {
        header.classList.add("color-inverse");
      }
    };

    if (!header.dataset.headerEventsBound) {
      document.addEventListener("keyup", onKeyUp);
      document.addEventListener("scroll", onScroll, { passive: true });

      header.addEventListener("mouseenter", addBackground);
      header.addEventListener("focus", addBackground);
      header.addEventListener("focusin", addBackground);
      header.addEventListener("mouseleave", removeBackground);
      header.addEventListener("focusout", removeBackground);

      header.dataset.headerEventsBound = "true";
    }
  };

  document.addEventListener("DOMContentLoaded", initHeader);
  document.addEventListener("shopify:section:load", initHeader);
  document.addEventListener("shopify:section:unload", initHeader);
  document.addEventListener("shopify:section:reorder", initHeader);
})();